import { Version } from '../types/version';
import BaseEntityService from './baseEntityService';

const serviceUrlSuffix = 'v1/versions'

class VersionService extends BaseEntityService<Version> {
    constructor() {
        super(serviceUrlSuffix);
    }
}

export const versionService = new VersionService();